import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=72f51ea0&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=ts&"
export * from "./BasicLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=72f51ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f51ea0",
  null
  
)

export default component.exports